var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model-index',{attrs:{"show_btn_remove_belongs_to_many":false,"prop_to_send_on_save":_vm.prop_to_send_on_save,"check_permissions":"","not_show_delete_text":"","model_name":"payment_plan"},scopedSlots:_vm._u([{key:"model_modal_header",fn:function(){return [_c('sale-info')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }